import React, { ComponentProps, useState } from "react";
import { Button } from "@clarkinc/zest-design-system/ui";
import { cls } from "@wss/cls";
import { initItemPage, nextPage } from "./module";
import RecommendedItem from "./components/RecommendedItem";
import Skeleton from "../Skeleton";
import { Category as CategoryData, RecommendedItem as RecommendedItemProps } from "./contracts";
interface CategoryProps extends CategoryData {
  loading?: boolean;
}
const Category = ({
  className,
  loading = true,
  categoryName,
  items = []
}: CategoryProps & ComponentProps<"div">) => {
  const [recommendations, setRecommendations] = useState<{
    page: number;
    items: RecommendedItemProps[];
  }>(initItemPage(items));
  const handleSeeMore = async () => {
    const newPage = await nextPage(recommendations.items, recommendations.page + 1);
    setRecommendations(newPage);
  };
  return <div className={cls("grid",
  // this is required to make the container border work correctly. I don't know why
  "w-full box-border min-w-[298px] p-4 border border-solid border-[#f1f1f1] rounded-md shadow-[0_1px_3px_rgba(0,0,0,0.1)] mb-1/2", "xl:min-w-[288px]", className)} data-sentry-component="Category" data-sentry-source-file="Category.tsx">
      <div className="flex justify-between w-full mb-3">
        {loading && <div className="w-full xl:h-8">
            <Skeleton className="xl:w-[70%] h-5" />
          </div> || <>
            <span>{categoryName}</span>
            <Button className="ml-4" variant="plain" onClick={handleSeeMore}>
              See More
            </Button>
          </>}
      </div>
      <div className={cls("grid grid-cols-2 gap-x-4 gap-y-4-1/2 items-center", "xl:gap-x-2 xl:gap-y-3", "xxxsl:gap-4")}>
        {recommendations.items.map(item => <RecommendedItem loading={loading} {...item} />)}
      </div>
    </div>;
};
export default Category;